export default "__VITE_ASSET__BSp9O0MU__"